import { MapFilter } from "../MapFilter";
import { MarketplaceListItem } from "../MarketplaceListItem";
import { ZipCode } from "../ZipCode";
import { ICacheStorage } from "./ICacheStorage";
import { MarketplaceListItemsCacheStorage } from "./MarketplaceListItemsCacheStorage";
import { ZipCodesCacheStorage } from "./ZipCodesCacheStorage";

export class MarketplaceMapCache {
    private zipCodesStorage: ICacheStorage<ZipCode>;
    private buildingsStorage: ICacheStorage<MarketplaceListItem>;
    private storages: Map<{ new(p: any): any }, ICacheStorage<any>>;

    public constructor() {
        this.zipCodesStorage = new ZipCodesCacheStorage();
        this.buildingsStorage = new MarketplaceListItemsCacheStorage();
        this.storages = new Map();
        this.storages.set(ZipCode, this.zipCodesStorage);
        this.storages.set(MarketplaceListItem, this.buildingsStorage);
    }

    public updateCache<T>(type: { new(params: any): T }, filter: MapFilter, data: T[], force: boolean = false): void {
        
        if (this.storages.has(type)) {
            this.storages.get(type).cacheData(filter, data, force);
        }
    }

    public getCachedData<T>(type: { new(params: any): T }, filter: MapFilter): T[] {
        if (this.storages.has(type)) {
            return this.storages.get(type).getCachedData(filter);
        }
        return [];
    }

}
